module.exports = __webpack_public_path__ + "img/web.d1f31329.png";